module.exports = __webpack_public_path__ + "static/img/solution_pro2.8a3c7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/solution_pro2.png
// module id = LRJj
// module chunks = 1